import {Injectable} from '@angular/core';
import {fromPromise} from 'rxjs/internal-compatibility';
import {Observable} from 'rxjs/internal/Observable';
import {of} from 'rxjs/internal/observable/of';
import {map, mergeMap, shareReplay} from 'rxjs/operators';
import {UserService} from '../../../shared/services/user/user.service';
import {AlertService} from '../../viewer/services/alert.service';
import {AlertContentInterface} from '../interfaces/alert-content.interface';
import {Notification, NotificationAuthorityType, NotificationBase} from '../interfaces/notification-base.interface';
import {NotificationWithSoundAlerts} from '../interfaces/notify-with-sound.interface';
import {AlertSocketService} from './alert-socket.service';
import {NotificationsConfigurationService} from './notifications-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AlertsNotificationsService extends NotificationWithSoundAlerts {
  constructor(
    private notificationsService: AlertSocketService,
    private alertService: AlertService,
    private userService: UserService,
  ) {
    super('alert', notificationsService);
    this.soundPath = '../assets/audio/alert2.mp3';
    this.join();
    this.configuration = new NotificationsConfigurationService();
    this.configuration.getSound$().subscribe(on => {
      if (on) {
        this.subscribeToSoundAlert();
      } else {
        this.unsubscribeToSoundAlert();
      }
    });
  }

  fromAlertToNotification(alert): NotificationBase {
    const alertContent: AlertContentInterface = {
      nodeRef: alert.nodeRef,
      authorities: alert.authorities,
      description: alert.comment,
      fileName: alert.title,
      seen: alert.lu === 'true',
      expireDateIso: new Date(alert.notifDate)
    };
    return {
      domain: 'alert',
      content: alertContent,
      authorities: [{
        type: NotificationAuthorityType.Single,
        value: alert.userId
      }],
      action: 'create',
      createdAt: null,
      metadata: null
    };
  }

  public unSeenAlerts() {
    return fromPromise(this.alertService.getUnreadAlerts()).pipe(
      shareReplay(),
      mergeMap((value: any[]) => {
       
        return of(...value);
      }),
      map(this.fromAlertToNotification)
    );
  }

  initNotifications(): Observable<Notification> {
   
    return this.unSeenAlerts();
  }

  join(): void {
    this.notificationSocket.on('connect', () => {
      this.userService.getCurrentUser().then(user => {
        this.notificationSocket.emit('join', user);
      });
    });
  }
}
